import React from 'react';
import KeyPickupEventInformation from 'src/components/BigCalender/EventDetailsDialog/components/EventInformation/KeyPickupEventInformation';
import CalcomEventDetailsSection from 'src/pages/Calendar/CalcomIntegration/components/CalcomEventDetails/CalcomEventDetails';
import KeyHandoffComponent from 'src/pages/Suite/KeyHandoffComponent';
import KeyHandoffComponentSkeleton from 'src/pages/Suite/skeletons/KeyHandoffComponentSkeleton';
import { Suite } from 'src/SharedCustomHooks/UseSuiteActions/types';
import { ICalendarEventData } from 'src/pages/Calendar/types';
import './key-pickup-content.scss';

interface KeyPickupContentProps {
  suite: Suite | null;
  keyPickupEvent: ICalendarEventData | null;
  onBackToSuite: () => void;
}

const KeyPickupContent = ({
  suite,
  keyPickupEvent,
  onBackToSuite,
}: KeyPickupContentProps) => {
  if (!suite) {
    return <KeyHandoffComponentSkeleton />;
  }

  return (
    <KeyHandoffComponent
      suiteFormData={suite}
      onClose={onBackToSuite}
      calComEventSummary={
        keyPickupEvent && (
          <div className="key-pickup-event-summary">
            <KeyPickupEventInformation
              originalEvent={keyPickupEvent}
              showViewUnitButton={false}
            />
            <CalcomEventDetailsSection
              event={keyPickupEvent}
              hideExplainer={true}
            />
          </div>
        )
      }
    />
  );
};

export default KeyPickupContent;